import { render, staticRenderFns } from "./xzcfsxgzsspb.vue?vue&type=template&id=71add8b7&scoped=true&"
import script from "./xzcfsxgzsspb.vue?vue&type=script&lang=js&"
export * from "./xzcfsxgzsspb.vue?vue&type=script&lang=js&"
import style0 from "./xzcfsxgzsspb.vue?vue&type=style&index=0&id=71add8b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71add8b7",
  null
  
)

export default component.exports